module.exports = __webpack_public_path__ + "img/YouTube_desktop_white.fb7223e3.svg";